import Measurement, { IMeasurementAPI } from '@/common/models/measurements/Measurement';
import Validatable from '@/validator/Validatable';

interface IOrganizationMeasurementAPI {
  organizationmeasurement_id: number;
  organization_id: number;
  measurement_id: number;
  measurement: IMeasurementAPI;
}

export default class OrganizationMeasurement extends Validatable {
  constructor(
    public id: number,
    public organizationID: number,
    public measurementID: number,
    public measurement?: Measurement,
  ) {
    super();
  }

  static fromApi(apiObject: IOrganizationMeasurementAPI): OrganizationMeasurement {
    return new OrganizationMeasurement(
      apiObject.organizationmeasurement_id,
      apiObject.organization_id,
      apiObject.measurement_id,
      apiObject.measurement ? Measurement.fromApi(apiObject.measurement) : null,
    );
  }

  toApi() {
    return {
      organizationmeasurement_id: this.id,
      organization_id: this.organizationID,
      measurement_id: this.measurementID,
    };
  }
}
